<template id="">
  <v-tooltip right :disabled="!$vuetify.breakpoint.mdAndUp">
    <template v-slot:activator="{ on, attrs }">
      <v-fab-transition>
        <v-btn
          fab
          v-bind="attrs"
          v-on="on"
          class="ma-2 button"
          v-show="showUpButton"
          small
          @click.stop="moveUp()"
          color="rgb(255,255,255)"
        >
          <v-img width="40px" :src="require(`../../assets/images/${getImage()}.png`)" />
        </v-btn>
      </v-fab-transition>
    </template>
    <span class="header-4-alt white--text">{{ this.getText }}</span>
  </v-tooltip>
</template>
<script>
import $ from "jquery";
export default {
  name: "ChangeLang",
  props: {
    //showUpButton: Boolean
  },
  data() {
    return {
      showUpButton: true
    };
  },
  computed: {
    getText() {
      return this.$i18n.locale === "en" ? "Español" : "English";
    }
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    toggleLocal() {
      // console.warn(`Antes: ${this.$i18n.locale}`);
      this.$i18n.locale = this.$i18n.locale === "en" ? "es" : "en";
      // console.warn(`Después: ${this.$i18n.locale}`);
    },
    getImage() {
      return this.$i18n.locale === "en" ? "es" : "en";
    },
    moveUp() {
      //---------------------------- Option 1
      // window.location = "#googtrans(es|en)";
      // location.reload();
      //---------------------------- Option 2
      if (this.$i18n.locale === "es") {
        this.toggleLocal();
        const language = "en";
        var selectField = document.querySelector("#google_translate_element select");
        for (var i = 0; i < selectField.children.length; i++) {
          var option = selectField.children[i];
          if (option.value == language) {
            selectField.selectedIndex = i;
            selectField.dispatchEvent(new Event("change"));
            break;
          }
        }
      } else {
        $("#\\:1\\.container")
          .contents()
          .find("#\\:1\\.restore")
          .click();
        this.toggleLocal();
      }
    },
    handleScroll(event) {
      if (window.scrollY < 500) {
        this.showUpButton = true;
      } else this.showUpButton = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  display: flex;
  z-index: 100;
  position: fixed;
  bottom: 45px;
  left: 25px;
}

@media (max-width: 960px) {
  .button {
    bottom: 15px;
    left: 15px;
  }
}
</style>
